import React from "react";
import styles from "./Header.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import CustomButton from "../ui/CustomButton/CustomButton";
import useAppSelector from "../../hooks/useAppSelector";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import LanguageSelect from "../shared/LanguageSelect/LanguageSelect";
import { useTranslation } from "react-i18next";
import ProfileSelect from "../ProfileSelect/ProfileSelect";
import logo from "../../assets/images/logo.svg";
import { environment } from "../../environment";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthorized } = useAppSelector((state) => state.userProfileSlice);

  const handleOnLogin = () => {
    navigate("/login");
  };

  const handleOnGetStarted = () => {
    navigate("/your-location");
  };

  return (
    <>
      <div className={styles.header}>
        <div className="container">
          <div className={styles.row}>
            <div className={styles.left}>
              <div className={styles.logo}>
                <img
                  onClick={() => {
                    navigate("/");
                  }}
                  src={logo}
                  alt={"logo"}
                />
              </div>
              <div className={styles.language}>
                <LanguageSelect />
              </div>
            </div>
            <div className={styles.burger}>
              <BurgerMenu />
            </div>

            <nav className={styles.nav}>
              <ul className={styles.menu}>
                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/"}
                  >
                    {t("Home")}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ""}`}
                    to={"/free-listing"}
                  >
                    {t("FreeListing")}
                  </NavLink>
                </li>
                {environment.environment === "production" && (
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        `${styles.link} ${isActive ? styles.active : ""}`
                      }
                      to={"/gyms-location"}
                    >
                      {t("FindClassesAppointments")}
                    </NavLink>
                  </li>
                )}
              </ul>
            </nav>
            <div className={styles.box}></div>
            {environment.environment === "development" && (
              <>
                {!isAuthorized ? (
                  <div className={styles.btns}>
                    <CustomButton
                      text={t("Login")}
                      type={"button"}
                      typeStyle={"outline"}
                      functionOnClick={() => handleOnLogin()}
                    />
                    <CustomButton
                      text={t("GetStarted")}
                      type={"button"}
                      typeStyle={"fill"}
                      functionOnClick={() => handleOnGetStarted()}
                    />
                  </div>
                ) : (
                  <ProfileSelect />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
